module.exports = __webpack_public_path__ + "static/media/qufus_logo.f8c171b5.svg";